import React, { useState, useEffect, useCallback } from 'react';
import { Label, Flexbox } from 'cw-ui-core';
import css from 'src/components/InputField/InputField.scss';
import _ from 'lodash';

const validateAgainstPattern = (value, pattern) => {
    if (value === '') return true;
    const match = value.match(pattern);
    return !_.isEmpty(match);
};

const InputField = ({
    heading = '',
    required = false,
    subHeading = '',
    value,
    className,
    children,
    automationName,
    onChange,

    invalid = false,
    matchPattern,
    setFieldValidity,
    onAfterChange = () => {},
}) => {
    const widget = React.Children.only(children);
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (!isValid) setFieldValidity(false);
        else setFieldValidity(true);
    }, [isValid]);

    const handleChange = useCallback(
        e => {
            if (onChange) {
                if (matchPattern) setIsValid(validateAgainstPattern(e, matchPattern));
                onChange(e);
            }
            onAfterChange();
        },
        [onChange, onAfterChange, matchPattern]
    );

    return (
        <Flexbox column className={className}>
            {!_.isEmpty(heading) && <Label value={required ? `${heading} *` : heading} className={css.heading} grey7 />}
            {!_.isEmpty(subHeading) && <Label value={subHeading} className={css.subHeading} />}
            {React.cloneElement(widget, {
                automationName,
                value,
                checked: !!value,
                invalid: !isValid || invalid,
                onChange: handleChange,
            })}
        </Flexbox>
    );
};

export default InputField;
